import StarterKit from "@tiptap/starter-kit";
import {
  BackgroundColor,
  Color,
  FontSize,
  TextStyle
} from "@tiptap/extension-text-style";
import { Indent } from "./extensions/indent";

/**
 * Everything the editor understands. StarterKit carries the marks and blocks the
 * toolbar drives plus the ones only pasted content produces (headings, links,
 * ordered lists), so pasting into a note keeps its structure. TextStyle and its
 * attribute extensions read and write the same inline `<span style>` that the
 * stored notes use, which is what lets existing content round-trip.
 */
export const EDITOR_EXTENSIONS = [
  StarterKit.configure({
    // Notes are read inside the admin page, so a click should never navigate the
    // operator away from the customer they are assessing.
    link: { openOnClick: false }
  }),
  TextStyle,
  Color,
  FontSize,
  BackgroundColor,
  Indent
];
